import $ from 'jquery';
import util from 'util/Util.js';

import { View } from 'backbone';

import _Template from 'properties/main/checkbox.ejs';
import mobileSyncService from "../../../service/mobile/MobileSyncService";

// PF-5745
import undoService from 'UndoService.js';
import textConstants        from 'TextConstants';


class MainCheckboxValueView extends View {



    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=checkbox]' : 'updateCheckAttributes'
        };

        if (this.model.get('selected') === undefined) {
            this.model.set('selected', false, {silent: true});
        }
        

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        const oldPropVal = this.model.get( 'selected');
        this.model.set( 'selected', propVal );

        mobileSyncService.synchronizeMobileForm(this.model, this.model.get('factoryKey'), {key: 'selected', val: propVal});

        //console.log(`MainHeaderView model.set(${propName}, ${this.model.get( propName )})`);

        undoService.add({
            undo: () => {
                this.model.set( 'selected', oldPropVal, {silent: true} );
                this.render();
            },
            redo: () => {
                this.model.set( 'selected', propVal, {silent: true} );
                this.render();
            }
          }, textConstants.UNDO_MOVE);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        let bSelected = util.isTrue(this.model.get('selected'));
        $(`input[name='isSelected']`).prop('checked', bSelected );
        
        this.delegateEvents();
        return this;
    }

}

export default MainCheckboxValueView;